export default {
  boletos: [],
  loading: false,
}
